<template>
  	<div class="module_page page_content institution payment_plans" aria-label="Institution Summary view content page">

    <div class="row page-heading">
      <div class="col-2 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
        <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-10 right-container">

        <template v-if="!showLoader">
          <template v-if="!showEditProgramAssignment">
            <template v-if="isPaymentGatewayEnabled">
              <template v-if="!paymentGateway.setupComplete">
                <div class="row pg_hd">
                  <div class="col-6 hd">
                    <div class="ace_sec_txt hd_txt">
                      {{ $t('pricingPlans') }}
                    </div>
                    <div class="ace_sec_txt hd_info">
                      Click on the 'connect' button to integrate with Stripe
                    </div>
                  </div>
                  <div class="col-6 btn_container">
                    <b-link class="btn" aria-label="connect" :href="stripeConnectLink">
                      {{ $t('connect') }}
                    </b-link>
                  </div>
                </div>
              </template>
              <template v-if="paymentGateway.setupComplete">
                <div class="row pg_hd">
                  <div class="col-6 hd">
                    <div class="ace_sec_txt hd_txt">
                      {{ $t('pricingPlans') }}
                    </div>
                  </div>
                  <div class="col-6 btn_container">
                    <b-btn class="btn" @click="openNewPricingPlanModal()">
                      {{ $t('addPricingPlan') }}
                    </b-btn>
                    <b-btn class="btn" @click="returnToEcommerce()">
                      {{ $t('backToEcom') }}
                    </b-btn>
                  </div>
                </div>
              </template>
            </template>
          </template>

          <template v-if="showEditProgramAssignment">
            <!-- assign plan header -->
            <div class="row pg_hd">
              <div class="col-6 hd">
                <div class="ace_sec_txt hd_txt">
                  <span class="ace_sec_txt hd_txt_inner">
                    Assign {{selectedPricingPlan.name}} to Program
                  </span>
                  <span class="ace_sec_txt hd_info">
                    <span>
                      (Price:
                      <span v-if="selectedPricingPlan.currency === 'usd'">$</span>
                      {{ selectedPricingPlan.price }}
                      )
                    </span>
                    <!--
                    <div class="" v-html="selectedPricingPlan.description"></div>
                    -->
                  </span>

                </div>
              </div>
              <div class="col-6 btn_container">
                <a href="javascript:void(0)" class="btn" @click="saveUpdateProgramGuideAssignment">
                  {{ $t('save') }}
                </a>
              </div>
            </div>
            <!-- assign plan header -->
          </template>
        </template>

      </div>
    </div>

	    <div class="page_content_container" :class="isNotCustomAdmin ? '' : 'no_left_nav'">

            <institution-menu :uuid="uuid" :active="'paymentgateway'"></institution-menu>


		      <div class="row pg_content">
			      <div class="col-12">
			          <b-jumbotron style="padding-top: 10px;">
                  <template v-if="!showLoader">
                    <template v-if="!showEditProgramAssignment">
                      <template v-if="isPaymentGatewayEnabled">
                        <template v-if="paymentGateway.setupComplete">
                           <!--
                           <div class="mt-4">
                             <h4 class="ace_sec_txt">Products</h4>
                             <table class="mt-2 table" v-if="institutionProducts.length > 0">
                               <thead>
                                 <td class="text-center ace_sec_txt">Product Name</td>
                                 <td class="text-center ace_sec_txt">Stripe Product Id</td>
                                 <td class="text-center ace_sec_txt">Stripe Price Id</td>
                                 <td class="text-center ace_sec_txt">Delete?</td>
                               </thead>
                               <tr v-for="product in institutionProducts">
                                 <td class="text-center ace_sec_txt">{{product.productName}}</td>
                                 <td class="text-center ace_sec_txt">{{product.stripeProductId}}</td>
                                 <td class="text-center ace_sec_txt">{{product.stripePriceId}}</td>
                                 <td class="text-center ace_sec_txt"><a @click="deleteProduct(product)">X</a></td>
                               </tr>
                              </table>
                               <p class="text-center ace_sec_txt" v-if="institutionProducts.length === 0">No products exist. Create on using the form below.</p>
                              <table class="mt-4 table">
                               <tr class="mt-2">
                                 <td class="text-center ace_sec_txt"><input placeholder="Product Name" v-model="newProduct.productName"></td>
                                 <td class="text-center ace_sec_txt"><input placeholder="Stripe Product ID" v-model="newProduct.stripeProductId"></td>
                                 <td class="text-center ace_sec_txt"><input placeholder="Stripe Price ID" v-model="newProduct.stripePriceId"></td>
                                 <td class="text-center ace_sec_txt"><a @click="addNewProduct()">+ Add Product</a></td>
                               </tr>
                             </table>
                           </div>
                            -->
                            <div class="">
                              <div class="mt-2" v-if="pricingPlans.length > 0">
                                <!--
                                <thead>
                                  <td class="text-center ace_sec_txt">Name</td>
                                  <td class="text-center ace_sec_txt">Description</td>
                                  <td class="text-center ace_sec_txt">Price</td>
                                  <td class="text-center ace_sec_txt">Type</td>
                                  <td class="text-center ace_sec_txt">Time Limit (in days)</td>
                                  <td class="text-center ace_sec_txt">Assign Program Guides</td>
                                  <td class="text-center ace_sec_txt">Delete?</td>
                                </thead>
                                -->
                                <div class="row plan_row" v-for="pricingPlan in pricingPlans">
                                  <div class="col-12">

                                    <div class="row">

                                      <div class="col-4">

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt title">
                                            {{pricingPlan.name}}
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 ace_sec_txt">
                                            <span v-if="pricingPlan.type === 'onetime'">
                                              {{ $t('oneTimePurchase') }}
                                            </span>
                                            <span v-if="pricingPlan.type === 'subscription-monthly'">
                                              {{ $t('subscriptionMonthly') }}
                                            </span>
                                            <span v-if="pricingPlan.type === 'subscription-monthly-payment-plan'">
                                              {{ $t('subscriptionMonthlyPaymentPlan') }}
                                            </span>
                                            <span v-if="pricingPlan.type === 'subscription-yearly'">
                                              {{ $t('SubscriptionYearly') }}
                                            </span>
                                          </div>
                                        </div>

                                        <div class="row col_row" v-if="pricingPlan.type === 'onetime'">
                                          <div class="col-12 ace_sec_txt">
                                            {{ pricingPlan.duration }}
                                            {{ $t('dayTimeLimit') }}
                                          </div>
                                        </div>

                                        <div class="row col_row">
                                          <div class="col-12 programs_list ace_sec_txt">
                                            <span class="sec_info" v-if="pricingPlan.programGuideObjects.length === 0">
                                              {{ $t('noProgramAssignedYetMsg') }}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="col-5">
                                        <div class="description">
                                          <div class="desc_txt" v-html="pricingPlan.description"></div>
                                        </div>
                                      </div>

                                      <div class="col-3">
                                        <div class="row">
                                          <div class="col-6 text-center">
                                            <span v-if="pricingPlan.currency === 'usd'">$</span>{{pricingPlan.price}}
                                          </div>
                                          <div class="col-6 text-center">
                                            <btn
                                              @click="showDeletePricingPlanConfirm(pricingPlan)"
                                              class="ic_btn"
                                              style="cursor: pointer"
                                              :title="$t('deleteTitle')"
                                              v-b-tooltip.hover>
                                                <span class="ic ic22-bin"></span>
                                            </btn>
                                          </div>
                                        </div>

                                        <div class="row">
                                          <div class="col-12 text-center lnk_container">
                                            <a @click="updateProgramGuideAssignment(pricingPlan)">
                                              {{ $t('assignPlanToPrograms') }}
                                            </a>
                                          </div>
                                        </div>
                                      </div>

                                    </div>

                                    <div class="row">
                                      <div class="col-12 programs_list ace_sec_txt">
                                        <span class="program" v-for="pg in pricingPlan.programGuideObjects">
                                          {{ pg.title }}
                                        </span>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>

                              <p class="text-center ace_sec_txt" v-if="pricingPlans.length === 0">
                                {{ $t('noPricingPlansMsg') }}
                              </p>
                            </div>

                        </template>
                      </template>
                      <template v-if="!isPaymentGatewayEnabled">
                        <h4 class="text-center ace_sec_txt">Please reach out to support@pragyasystems.com to enable this feature.</h4>
                      </template>
                    </template>
                    <template v-if="showEditProgramAssignment">
                      <div class="assign_plan">

                        <div class="row filter_bar">
                          <div class="col-6 select_all">
                            <input type="checkbox" v-model="selectAllProgramGuides" @change="selectUnselectAllProgramGuides($event)">
                            <label>
                              {{ $t('allPrograms') }}
                            </label>
                          </div>
                          <div class="col-6 btn_container">
                            <div class="srh_bx">
                              <input
                                v-model="searchQuery"
                                placeholder="Search for programs"
                                class="">
                              <span class="ic ic22-search"></span>
                            </div>
                          </div>
                        </div>

                        <!--
                        <div class="mt-4">
                          <multiselect v-model="selectedProgramGuides" :options="programGuides" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select Program Guide" label="title" track-by="uuid" style="width: 96%;">
                          </multiselect>
                        </div>
                        -->
                        <div class="row programs_list">
                          <div class="col-12">

                            <div class="row">
                              <div class="col-12 program" v-for="pg in programGuides">
                                <input type="checkbox" :id="pg.uuid" :value="pg.uuid" v-model="selectedProgramGuides" @change="deleteAssignmentProgramGuide($event, pg)">
                                <label :for="pg.uuid">{{pg.title}}</label>
                              </div>
                            </div>

                          </div>
                        </div>

                      </div>

                    </template>
                  </template>
                  <template v-if="showLoader">
                    <p class="text-center ace_sec_txt">Loading..</p>
                  </template>
			          </b-jumbotron>
			      </div>
		      </div>
	    </div>
      <!-- New Pricing Plan Modal -->
      <div>
        <b-modal class="modal__v22_2 price_plan_modal add_plan_modal" id="new-pricing-plan-modal-popup" ref="newPricingPlanModal" :header-bg-variant="'subscribe-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>

          <div slot="modal-header" class="w-100">
  					<div class="row">

  	          <div class="col-3 hd">
  							<div class="ic_container">
  								<span class="ic ic22-buy"></span>
  							</div>
  						</div>
              <div class="col-6 hd">
  							<div class="hd_txt txt_center">
  		            <span>
                    {{ $t('addAPricingPlan') }}
                  </span>
                </div>
  						</div>
  						<div class="col-3 btn_container">

                <a class="btn" @click="addNewPricingPlan()">
                  {{ $t('save') }}
                </a>

  							<button
                  @click="closeNewPricingPlanModal"
                  class="btn_close"
                  :aria-label="$t('closeAria')"
                  :title="$t('closePopupTitle')"
                  v-b-tooltip.hover>
  	               <span class="ic-close"></span>
  	            </button>
  						</div>
  					</div>
  				</div>

          <div class="row content_container">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 form_section">

              <p v-if="showPricingPlanCreationError" class="text-red">
                {{ pricingPlanErrorMessage }}
              </p>

              <div class="row price_plan_sec">
                <div class="col-12 sec_content">

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="name">
                        {{ $t('name') }} *
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newPricingPlan.name">
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('type') }}
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <select v-model="newPricingPlan.type">
                        <option value="onetime">
                          {{ $t('oneTime') }}
                        </option>
                        <option value="subscription-monthly">
                          {{ $t('subscriptionMonthly') }}
                        </option>
                        <option value="subscription-monthly-payment-plan">
                          {{ $t('subscriptionMonthlyPaymentPlan') }}
                        </option>
                        <option value="subscription-yearly">
                          {{ $t('SubscriptionYearly') }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row sec_row fld_row" v-if="newPricingPlan.type === 'onetime'">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('timeLimitInDays') }} *
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newPricingPlan.duration" type="number">
                    </div>
                  </div>
                  <div class="row sec_row fld_row" v-if="newPricingPlan.type === 'subscription-monthly-payment-plan'">
                    <div class="col-12 fld_label">
                      <label class="label" for="allowCancleAfterMonths">
                        {{ $t('allowCancelAfterMonths') }}
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newPricingPlan.allowCancleAfterMonths" type="number"> {{ $t('months') }}
                    </div>
                  </div>
                  <div class="row sec_row fld_row" v-if="newPricingPlan.type !== 'onetime'">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('includedProgram') }}
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <select v-model="newPricingPlan.includedProgram">
                        <option value="ONE">
                          {{ $t('one') }}
                        </option>
                        <option value="ALL">
                          {{ $t('all') }}
                        </option>
                        <option value="SOME">
                          {{ $t('associated') }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('priceCurrency') }}
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <select v-model="newPricingPlan.currency">
                        <option value="usd">$ Dollar</option>
                      </select>
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('priceAmount') }} *
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <input v-model="newPricingPlan.price" type="number">
                    </div>
                  </div>

                  <div class="row sec_row fld_row">
                    <div class="col-12 fld_label">
                      <label class="label" for="institutionType">
                        {{ $t('description') }}
                      </label>
                    </div>
                    <div class="col-12 fld_input">
                      <div class="description_bx">
                        <editor api-key="no-api-key"
                          v-model="newPricingPlan.description"
                          :init="{
                            base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
                            menubar: false,
                            plugins: plugins,
                            toolbar: toolbar,
                            branding: false,
                            statusbar: false
                          }">
                        </editor>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>

        </b-modal>
      </div>
      <!-- New Pricing Plan Modal Ends -->

      <!-- Delete Pricing Plan Modal -->
      <div>
        <b-modal class="modal__v22_2" ref="deletePricingPlanModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered>
          <div slot="modal-header" class="w-100">
  					<div class="row">

  	          <div class="col-3 hd">
  							<div class="ic_container">
  								<span class="ic ic22-warning"></span>
  							</div>
  						</div>
              <div class="col-6 hd">
  							<div class="hd_txt txt_center">
  		            <span>
                    {{ $t('pleaseConfirm') }}
                  </span>
                </div>
  						</div>
  						<div class="col-3 btn_container">
                <button
                  @click="hideDeleteConfirmBox"
                  class="btn_close"
                  :aria-label="$t('closeAria')"
                  :title="$t('closePopupTitle')"
                  v-b-tooltip.hover>
  	               <span class="ic-close"></span>
  	            </button>
  						</div>
  					</div>
  				</div>

          <div>
            <span>
              {{ $t('confirmDeletePricingPlanMsg')}}
            </span>
          </div>

          <div slot="modal-footer" class="w-100">
            <b-button
              @click="deletePricingPlan"
              class="btn button-primary float-right mr-2"
              :aria-label="$t('yesAria')">
                {{ $t('yes') }}
            </b-button>
            <b-button
              @click="hideDeleteConfirmBox"
              class="btn button-primary float-right mr-2"
              :aria-label="$t('no')">
                {{ $t('no') }}
            </b-button>
          </div>
        </b-modal>
      </div>
      <!-- Delete Pricing Plan Ends -->
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import { PACKAGE } from '../../../package_constants'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'institutionPricingPlans',
  props: ['uuid'],
  components: {
    InstitutionMenu,
    InstitutionHeader,
    Editor
  },
  data: () => {
    return {
      uObj: JSON.parse(localStorage.getItem('userobj')),
      userrole: localStorage.getItem('userrole'),
      paymentGateway: {},
      stripeConnectLink: "",
      showLoader: false,
      institutionProducts: [],
      pricingPlans: [],
      isStripeConnected: true,
      newPricingPlan: {
        name: '',
        description: '',
        currency: 'usd',
        price: 0.0,
        type: 'onetime',
        duration: 0,
        allowCancleAfterMonths:0,
        includedProgram:"ONE",
        items: []
      },
      showPricingPlanCreationError: false,
      pricingPlanErrorMessage: '',
      showEditProgramAssignment: false,
      selectedPricingPlan: {},
      newProduct: {
        productName: '',
        stripeProductId: '',
        stripePriceId: ''
      },
      selectedProgramGuides: [],
      programGuides: [],
      searchQuery: '',
      selectAllProgramGuides: false,
      pricingPlanToBeDeleted: {},
      plugins: 'lists  autolink charmap code hr link textcolor',
      toolbar: 'bold italic strikethrough | bullist numlist | indent outdent | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink',
    }
  },
  mounted () {
    this.loadInstitution()
  },
  methods: {
    ...mapActions([
      'loadInstitutionDetail',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'loadInstitutionPaymentGateway',
      'loadStripeConnectUrl',
      'loadInstitutionProducts',
      'loadCreateInstitutionProduct',
      'loadDeleteInstitutionProduct',
      'loadInstitutionPricingPlans',
      'loadCreateInstitutionPricingPlan',
      'loadDeleteInstitutionPricingPlan',
      'loadProgramGuides',
      'loadPutAssignProgramGuide',
      'loadPutDeleteAssignmentProgramGuide'
    ]),
    returnToEcommerce () {
      return this.$router.push({ name: 'institutionPaymentGateway', params: { uuid: this.uuid } })
    },
    async loadInstitution () {
      this.showLoader = true
      await this.loadLogDashboardActivity({action: 'viewInstitutionSummaryView', page: 'institutionSummaryView', link: '', entityUuid: this.uuid})
      await this.loadInstitutionDetail(this.uuid)
      this.paymentGateway = await this.loadInstitutionPaymentGateway()
      if (!this.paymentGateway.setupComplete) {
        this.stripeConnectLink = await this.loadStripeConnectUrl()
      }
      if (this.paymentGateway.setupComplete) {
        // this.institutionProducts = await this.loadInstitutionProducts()
        this.pricingPlans = await this.loadInstitutionPricingPlans()
        this.loadProgramGuides({page: 0, count: 100000, title: ''}).then(result => {
          this.programGuides = result.content
        })
      }
      this.showLoader = false
    },
    updateProgramGuideResults () {
      this.loadProgramGuides({page: 0, count: 100000, title: this.searchQuery}).then(result => {
        this.programGuides = result.content
      })
    },
    async addNewProduct() {
      if (this.newProduct.productName.length > 0 && this.newProduct.stripeProductId.length > 0 && this.newProduct.stripePriceId.length > 0) {
        this.showLoader = true
        await this.loadCreateInstitutionProduct(this.newProduct)
        this.institutionProducts = await this.loadInstitutionProducts()
        this.newProduct = {
          productName: '',
          stripeProductId: '',
          stripePriceId: ''
        }
        this.showLoader = false
      }
    },
    async deleteProduct(product) {
      this.showLoader = true
      await this.loadDeleteInstitutionProduct(product.uuid)
      this.institutionProducts = await this.loadInstitutionProducts()
      this.showLoader = false
    },
    openNewPricingPlanModal () {
      this.$refs.newPricingPlanModal.show()
    },
    closeNewPricingPlanModal () {
      this.newPricingPlan = {
        name: '',
        description: '',
        currency: 'usd',
        price: 0.0,
        type: 'onetime',
        items: [],
        duration: 0
      }
      this.$refs.newPricingPlanModal.hide()
    },
    async addNewPricingPlan() {
      this.showPricingPlanCreationError = false
      if (this.newPricingPlan.type === 'subscription-monthly') {
        this.newPricingPlan.duration = 30
        this.newPricingPlan.allowCancleAfterMonths=0
      } else if (this.newPricingPlan.type === 'subscription-monthly-payment-plan') {
        this.newPricingPlan.duration = 30
      } else if (this.newPricingPlan.type === 'subscription-yearly') {
        this.newPricingPlan.duration = 365
        this.newPricingPlan.allowCancleAfterMonths=0
      }
      if (this.newPricingPlan.name.length > 0 && this.newPricingPlan.duration > 0 && this.newPricingPlan.price > 0) {
        this.showLoader = true
        let item = {
          name: this.newPricingPlan.name,
          description: this.newPricingPlan.description,
          price: this.newPricingPlan.price,
          optional: false,
          type: this.newPricingPlan.type
        }

        this.newPricingPlan.items.push(item)
        await this.loadCreateInstitutionPricingPlan(this.newPricingPlan)
        this.pricingPlans = await this.loadInstitutionPricingPlans()
        this.newPricingPlan = {
          name: '',
          description: '',
          currency: 'usd',
          price: 0.0,
          type: 'onetime',
          items: [],
          duration: 0
        }
        this.showLoader = false
        this.closeNewPricingPlanModal()
      } else {
        this.pricingPlanErrorMessage = this.$t('addPricingPlanErrorMsg')
        this.showPricingPlanCreationError = true
      }
    },
    showDeletePricingPlanConfirm (pricingPlan) {
      this.pricingPlanToBeDeleted = pricingPlan
      this.$refs.deletePricingPlanModal.show()
    },
    hideDeleteConfirmBox () {
      this.pricingPlanToBeDeleted = {}
      this.$refs.deletePricingPlanModal.hide()
    },
    async deletePricingPlan() {
      this.showLoader = true
      await this.loadDeleteInstitutionPricingPlan(this.pricingPlanToBeDeleted.uuid)
      this.pricingPlanToBeDeleted = {}
      this.$refs.deletePricingPlanModal.hide()
      this.pricingPlans = await this.loadInstitutionPricingPlans()
      this.showLoader = false
    },
    updateProgramGuideAssignment (pricingPlan) {
      this.selectedPricingPlan = pricingPlan
      pricingPlan.programGuideObjects.forEach((item, i) => {
        this.selectedProgramGuides.push(item.uuid)
      })
      this.showEditProgramAssignment = true
      if (this.selectedProgramGuides.length === this.programGuides.length) {
        this.selectAllProgramGuides = true
      } else {
        this.selectAllProgramGuides = false
      }
    },
    async saveUpdateProgramGuideAssignment() {
      let programGuideIds = []
      this.selectedProgramGuides.forEach((item, i) => {
        programGuideIds.push(item)
      })

      await this.loadPutAssignProgramGuide({institutionPricingPlanId: this.selectedPricingPlan.uuid, programGuides: programGuideIds})
      this.pricingPlans = await this.loadInstitutionPricingPlans()
      this.selectedPricingPlan = {}
      this.selectedProgramGuides = []
      this.showEditProgramAssignment = false
    },
    async deleteAssignmentProgramGuide (e, programGuide) {
      if (!e.target.checked) {
        let pgList = []
        pgList.push(programGuide.uuid)
        await this.loadPutDeleteAssignmentProgramGuide({institutionPricingPlanId: this.selectedPricingPlan.uuid, programGuides: pgList})
        this.pricingPlans = await this.loadInstitutionPricingPlans()
      }
    },
    async selectUnselectAllProgramGuides (e) {
      if (e.target.checked) {
        // select all programs
        this.programGuides.forEach((item, i) => {
          if (this.selectedProgramGuides.indexOf(item.uuid) === -1) {
            this.selectedProgramGuides.push(item.uuid)
          }
        })
      } else {
        // unselect all selected programs and call delete
        let pgList = []
        this.selectedProgramGuides.forEach((item, i) => {
          pgList.push(item)
        })
        this.selectedProgramGuides = []
        await this.loadPutDeleteAssignmentProgramGuide({institutionPricingPlanId: this.selectedPricingPlan.uuid, programGuides: pgList})
        this.pricingPlans = await this.loadInstitutionPricingPlans()
      }
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'enabledFeatures': state => state.institution.enabledFeatures,
    }),
    isPaymentGatewayEnabled () {
      let paymentGateway = this.enabledFeatures[PACKAGE.FEATURE_IDS.PAYMENT_INTEGRATION]
      if (paymentGateway) {
        return paymentGateway.enabled
      }
      return false
    },
    isNotCustomAdmin () {
      let currentUser = JSON.parse(localStorage.getItem('userobj'))
      return !(currentUser && currentUser.customAdmin)
    }
  },
  watch: {
    searchQuery (newSearchQuery) {
      this.updateProgramGuideResults()
    }
  }
}
</script>
<style>
.text-green {
  color: green;
}

.text-red {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionPricingPlans.vue